module.exports = __webpack_public_path__ + "assets/img/goods_adv2.6ace9cda.jpg";